import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-lastpass',
  templateUrl: './lastpass.component.html',
  styleUrls: ['./lastpass.component.scss']
})
export class LastpassComponent implements OnInit {

  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['lastpass'];
  }

}
